import CheckIcon from '@mui/icons-material/Check'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { ButtonBase, Drawer, IconButton, Stack } from '@mui/material'
import { useState } from 'react'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { usePersonaStore } from '../../../../../store/usePersonaStore'
import FilterChip from '../../../../portal/lesson/booking/TutorFilterControls/FilterChip'
import { ageItems, genderItems, pronunciationItems } from './content'
import { getPronunciationName } from './getNames'

const BioInfo = () => {
  const { locale } = useTranslation()
  const { ageId, setAgeId, setPronunciationId, pronunciationId, genderId, setGenderId } = usePersonaStore()
  const [isOpenForPronunciation, setIsOpenForPronunciation] = useState(false)

  const selectPronunciation = (id) => {
    setIsOpenForPronunciation(false)
    setPronunciationId(id)
  }
  return (
    <div className="flex flex-col p-[20px]">
      <span className="Headline3-22Bd">이 사람의 정보를 알려주세요.</span>
      <span className="Caption-12Md text-gray-500 mt-[10px]">
        대화 중 AI의 목소리와 영어 억양에 반영되며, 미선택시 기본 음성/미국 억양으로 설정됩니다.
      </span>
      <div className="mt-[32px]">
        <span className="Title2-18Bd">억양</span>
        <div
          onClick={(e) => setIsOpenForPronunciation(true)}
          className="border-gray-300 items-center flex px-[12px] mt-[12px]"
          style={{ borderWidth: 1, height: 42, borderRadius: 8, position: 'relative' }}
        >
          {getPronunciationName(pronunciationId, locale)}
          <IconButton style={{ position: 'absolute', right: 0, top: 0 }}>
            <KeyboardArrowDownIcon />
          </IconButton>
        </div>
      </div>
      <div className="mt-[32px]">
        <div className="flex flex-row items-center">
          <span className="Title2-18Bd">연령대</span>
          <span className="Body1-16Md text-gray-400">(선택)</span>
        </div>

        <div className="flex flex-row mt-[12px] gap-[8px]" style={{ justifyContent: 'space-between' }}>
          {ageItems.map((item) => (
            <FilterChip
              showIcon={false}
              key={item.id}
              id={item.alt}
              name={item.value}
              checked={ageId === item.id}
              onClick={() => setAgeId(item.id)}
            />
          ))}
        </div>
      </div>

      <div className="mt-[32px]">
        <div className="flex flex-row items-center">
          <span className="Title2-18Bd">성별</span>
          <span className="Body1-16Md text-gray-400">(선택)</span>
        </div>

        <div className="flex flex-row mt-[12px] gap-[8px]" style={{}}>
          {genderItems.map((item) => (
            <FilterChip
              key={item.id}
              id={item.alt}
              name={item.value}
              checked={genderId === item.id}
              onClick={() => setGenderId(item.id)}
            />
          ))}
        </div>
      </div>

      <Drawer
        open={isOpenForPronunciation}
        anchor={'bottom'}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
        onClose={(_e) => setIsOpenForPronunciation(false)}
      >
        <div
          style={{
            height: '70vh', // ✅ works as intended
            padding: 20,
            maxHeight: '40%',

            borderTopLeftRadius: 24,
            borderTopRightRadius: 24,
            backgroundColor: 'white',
            overflowY: 'scroll',
          }}
        >
          <Stack>
            <span className="Title2-18Md">억양</span>
            {pronunciationItems.map((pronunciation, index) => {
              return (
                <ButtonBase
                  key={index}
                  style={{ height: 54 }}
                  sx={{ justifyContent: 'space-between' }}
                  onClick={(e) => selectPronunciation(pronunciation.id)}
                >
                  <div className="Body2-14Md">{getPronunciationName(pronunciation.id, locale)}</div>
                  {pronunciation.id === pronunciationId && (
                    <>
                      <CheckIcon />
                    </>
                  )}
                </ButtonBase>
              )
            })}
          </Stack>
        </div>
      </Drawer>
    </div>
  )
}

export default BioInfo
